/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Pageable } from '../../models/pageable';
import { PagedModelConfigResponse } from '../../models/paged-model-config-response';
import { PagedResourcesAssemblerConfig } from '../../models/paged-resources-assembler-config';

export interface GetConfigs$Params {
  merchantId?: string;
  siteId?: string;
  configType?: 'PRICE' | 'DISCOUNT' | 'QUANTITY_DISCOUNT' | 'NO_OP';
  enabled?: boolean;
  pageable: Pageable;
  assembler: PagedResourcesAssemblerConfig;
}

export function getConfigs(http: HttpClient, rootUrl: string, params: GetConfigs$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelConfigResponse>> {
  const rb = new RequestBuilder(rootUrl, getConfigs.PATH, 'get');
  if (params) {
    rb.query('merchantId', params.merchantId, {});
    rb.query('siteId', params.siteId, {});
    rb.query('configType', params.configType, {});
    rb.query('enabled', params.enabled, {});
    rb.query('pageable', params.pageable, {});
    rb.query('assembler', params.assembler, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelConfigResponse>;
    })
  );
}

getConfigs.PATH = '/configs';
